(() => {
  function mount() {
    document.querySelectorAll('[data-arm-pricing-root]').forEach(root => {
      if (root.dataset.armPricingReady) return;
      const data = root.querySelector('[data-arm-variants]');
      if (!data) return;
      const variants = JSON.parse(data.textContent);
      const select = root.querySelector('#arm-colour-select, select[name="id"], [data-arm-pricing-choice]');
      if (!select) return;
      function update() {
        const variant = variants.find(item => item.id === String(select.value));
        if (!variant) return;
        const discounted = variant.compareAtAmount > variant.priceAmount;
        root.querySelectorAll('[data-arm-sku]').forEach(element => { element.textContent = variant.sku || ''; });
        root.querySelectorAll('[data-arm-sku-row]').forEach(element => { element.hidden = !variant.sku; });
        root.querySelectorAll('[data-arm-price-block]').forEach(block => {
          block.querySelector('[data-arm-price]').textContent = variant.price;
          block.querySelector('[data-arm-rrp]').textContent = variant.compareAt || '';
          block.querySelector('[data-arm-saving]').textContent = variant.savings || '';
          block.querySelector('[data-arm-rrp-row]').hidden = !discounted;
          block.querySelector('[data-arm-saving-row]').hidden = !discounted;
          block.querySelector('[data-arm-price-label]').textContent = discounted ? data.dataset.ourPriceLabel : data.dataset.regularPriceLabel;
        });
        const speakerStock = root.querySelector('[data-arm-speaker-stock]');
        if (speakerStock) speakerStock.textContent = variant.stockState === 'stock' ? speakerStock.dataset.stockLabel : speakerStock.dataset.orderLabel;
        const availability = root.querySelector('[data-arm-availability]');
        if (availability && variant.stockState) {
          const state = variant.stockState;
          const purchase = root.querySelector('[data-arm-purchase]');
          if (purchase) purchase.classList.toggle('arm-preorder-purchase', state === 'preorder');
          root.querySelectorAll('[data-arm-check-availability]').forEach(button => { button.textContent = availability.dataset[state === 'preorder' ? 'enquireLabel' : 'checkLabel']; });
          availability.className = 'arm-availability arm-availability--' + state;
          availability.querySelector('[data-arm-availability-title]').textContent = availability.dataset[state + 'Title'];
          availability.querySelector('[data-arm-availability-detail]').textContent = availability.dataset[state + 'Detail'];
          root.querySelectorAll('[data-arm-enquiry-wrapper], [data-arm-check-availability], [data-arm-availability-footnote]').forEach(element => { element.hidden = state === 'stock' && !root.hasAttribute('data-arm-delivery-arrangement'); });
          root.querySelectorAll('#ARMProductForm button[type="submit"], #ARMTrio6ProductForm button[type="submit"]').forEach(button => {
            button.disabled = !variant.available;
            button.textContent = availability.dataset[state === 'stock' ? 'stockButton' : state === 'preorder' ? 'preorderButton' : state === 'unavailable' ? 'unavailableButton' : 'orderButton'];
          });
          const property = root.querySelector('input[name^="properties["]');
          if (property) property.value = availability.dataset[state + 'Title'] + (state === 'stock' ? '' : ' — ' + availability.dataset[state + 'Detail']);
          const contactSku = root.querySelector('[data-arm-contact-sku]');
          if (contactSku) contactSku.value = variant.sku || '';
        }
        if (variant.image) root.querySelectorAll('[data-arm-price-preview-image]').forEach(image => {
          image.src = variant.image;
          image.alt = variant.alt;
        });
      }
      select.addEventListener('change', update);
      window.addEventListener('popstate', update);
      root.dataset.armPricingReady = 'true';
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();


